import React, { createContext, useCallback, useContext } from "react";
import { useToast } from "../hooks";
import { ErrorContextType } from "../interfaces/all";
import { ErrorHandler } from "../utils/error-handler";

const ErrorContext = createContext<ErrorContextType | undefined>(undefined);

export const useErrorHandler = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error("useErrorHandler must be used within an ErrorProvider");
  }
  return context;
};

export const ErrorProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { error: showErrorToast } = useToast();

  const handleError = useCallback(
    (error: unknown) => {
      const errorResponse = ErrorHandler.handleApiError(error);
      // Não mostra erros de autenticação, pois são tratados pelo AccountProvider
      if (errorResponse.type !== "authentication") {
        showErrorToast(errorResponse.userMessage);
      }
    },
    [showErrorToast],
  );

  return (
    <ErrorContext.Provider value={{ handleError }}>
      {children}
    </ErrorContext.Provider>
  );
};
